import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  class: "modal-title fs-5",
  id: "pdfModalLabel"
}, "Export PDF", -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { id: "ExportPdfForm" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm",
  for: "documentTitle"
}, " Title ", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm",
  for: "documentDate"
}, " Date ", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-2 form-check-label mb-2",
  for: "withAnswers"
}, " Answers included ", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-2 form-check-label mb-4",
  for: "withSolutions"
}, " Solutions included ", -1)
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  id: "selectedExercisesList",
  class: "list-group mb-4"
}
const _hoisted_17 = { class: "container ps-0 pe-0" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-2" }
const _hoisted_20 = { class: "col-7 ps-0" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = ["aria-valuenow"]
const _hoisted_24 = { class: "invalid-feedback" }
const _hoisted_25 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          ref: "closeModal",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
        }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm mb-2",
              placeholder: "Test",
              id: "documentTitle",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event))
            }, null, 512), [
              [_vModelText, _ctx.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm mb-4",
              id: "documentDate",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event))
            }, null, 512), [
              [_vModelText, _ctx.date]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "withAnswers",
              value: "withAnswers",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.withAnswers) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.withAnswers]
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "withSolutions",
              value: "withSolutions",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.withSolutions) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.withSolutions]
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedExercises, (ex, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "list-group-item"
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString("#" + ex["id"]), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", {
                          class: "text-start wrap-text",
                          role: "button",
                          innerHTML: _ctx.processMath(ex)
                        }, null, 8, _hoisted_21)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: _normalizeClass(["progress", 
                (_ctx.showProgress ? '' : 'd-none') +
                ' ' +
                (_ctx.statusError != '' ? 'is-invalid' : '')
              ])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["progress-bar", 
                  (_ctx.stripedProgress ? 'progress-bar-striped' : '') +
                  ' ' +
                  (_ctx.animatedProgress ? 'progress-bar-animated' : '') +
                  ' ' +
                  (_ctx.progressBarDanger ? 'bg-danger' : 'bg-info')
                ]),
                style: _normalizeStyle(`width: ${_ctx.progressBarPercentage}%`),
                role: "progressbar",
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                "aria-valuenow": _ctx.progressBarPercentage
              }, null, 14, _hoisted_23)
            ], 2),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.statusError), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-bs-dismiss": "modal",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
        }, " Cancel "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exportPdf && _ctx.exportPdf(...args)))
        }, " Export PDF ")
      ])
    ])
  ]))
}